import {useEffect} from 'react';

export const useKeyboard = (
  keyboardHandler: (evt: KeyboardEvent) => void
): void => {
  useEffect(() => {
    document.addEventListener('keydown', keyboardHandler);
    return () => document.removeEventListener('keydown', keyboardHandler);
  }, [keyboardHandler]);
};

export const keyboardShortcutSearchHandler = (
  event: KeyboardEvent,
  actionFunction: () => void
): void => {
  const hasCtrlModifier = event.ctrlKey || event.metaKey;

  if (hasCtrlModifier) {
    if (event.key === 'f') {
      event.preventDefault();
      event.stopPropagation();
      actionFunction();
    }
  }
};

export const stopEvent = (event: React.KeyboardEvent): void => {
  event.preventDefault();
  event.stopPropagation();
};
